import React from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import TimeInput from "./TimeInput";

// var moment = require('jalali-moment');
let moment = require('moment-timezone');

class MonthlyCalendarInput extends React.Component {

    state = {
        // title: moment(),
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        dateVariables: [
            { name: "{{lang}}Now", value: '{{NOW}}', date: moment().format('ddd') },

            { name: "{{lang}}Today", value: '{{TODAY}}', date: moment().format('ddd') },
            { name: "{{lang}}6h Later", value: '{{LATER}}', date: moment().add(6, 'hours').format("HH:mm") },
            { name: "{{lang}}Tomorrow", value: '{{TOMORROW}}', date: moment().add(1, 'days').format("ddd") },
            { name: "{{lang}}Weekend", value: '{{WEEKEND}}', date: moment().add(0, 'week').isoWeekday(6).format("MMM DD") },
            { name: "{{lang}}Next Week", value: '{{NEXT WEEK}}', date: moment().add(1, 'week').format("MMM DD") },
            { name: "{{lang}}Next Weekend", value: '{{NEXT WEEKEND}}', date: moment().add(1, 'week').isoWeekday(6).format("MMM DD") },
            { name: "{{lang}}2 Weeks", value: '{{2 WEEKS}}', date: moment().add(2, 'weeks').format("MMM DD") },
            { name: "{{lang}}4 Weeks", value: '{{4 WEEKS}}', date: moment().add(4, 'weeks').format("MMM DD") },
            { name: "{{lang}}8 Weeks", value: '{{8 WEEKS}}', date: moment().add(8, 'weeks').format("MMM DD") },

        ],

        // currentTime
    }

    componentDidMount() {
        // console.log(moment().day())
        // let now = new Date().getTime() 
        // this.setState({ title: noew })

        this.setState({ title: this.props.data, today: new Date().getTime() })
        // // this.props.changeValue(this.props.header.key, day.start)

        // console.log(this.props.data)
        // this.setMonth(0)
        if (this.props.data) {
            this.setMonth(0, this.props.data)

        } else {
            this.setMonth(0)
        }
    }

    componentDidUpdate(prevProps) {

        if (String(prevProps.data) != String(this.props.data)) {


            this.setMonth(0, this.props.data)
            this.setState({ title: this.props.data })
        }
    }





    changeMonth(number) {

        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }
    changeYear(number) {

        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {

        // this.setState({month:{}},()=>{



        let now = new Date();
        let days = []



        let start = moment(now).add(fromNow, 'month').startOf('month')


        if (startDate) {

            if (!(typeof startDate == 'string' && startDate.startsWith('{{'))) {

                start = moment(startDate).add(fromNow, 'month').startOf('month')
            } else {
                start = moment(now).add(this.state.monthFromNow, 'month').startOf('month')

            }
        }

        // let end = moment(now).add(fromNow, 'month').endOf('month')
        // let count = 0


        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {

            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })
            // count++
        }

        // console.log(start)
        // console.log(days)

        // console.log(days)

        // this.setState({ isOpen: false }, () => {
        this.setState({ showDaysComponent: false }, () => {
            this.setState({ month: { title: moment(start).format('YYYY-MMMM'), startDay: start.day(), days: days } }, () => {

                this.setState({ showDaysComponent: true })
            })

        })
        // })
        // console.log(start.unix())
        // console.log(end.day())
        // })
    }

    setDay(day) {

        let startOrEnd = this.props.startOrEnd ? this.props.startOrEnd : "start"
        if (!this.props.startOrEnd && this.props.header.information?.startOrEnd) {
            startOrEnd = this.props.header.information.startOrEnd
        }
        this.setState({ title: day[startOrEnd] })

        if (this.state.time) {
            let time = this.state.time
            let timeByMin = this.timeStringToTimeByMin(time)
            let formatted = moment(day.start).startOf('day').add(timeByMin, 'seconds').valueOf()

            // console.log(timeByMin, formatted)
            this.props.changeValue(this.props.header.key, formatted, this.props.extra)

        } else {
            this.props.changeValue(this.props.header.key, day[startOrEnd], this.props.extra)
        }

        // console.log()

    }

    showDays() {

        // let day = 1
        if (Array.isArray(this.state.month?.days)) {
            let week = []
            let weeks = []
            let days = []
            let startDay = this.state.month.startDay

            // let firstWeek = true
            let count = 0
            startDay = startDay === 0 ? 7 : startDay
            if (startDay != 7) {
                for (let i = -1; i < startDay - 1; i++) {
                    days.push(null)
                }
            }

            // console.log('this.state.month.days', this.state.month.days)

            days = [...days, ...this.state.month.days]

            // console.log('days', days)

            for (let i = 0; i < days.length; i++) {
                // console.log("HERE")
                count++
                week.push(days[i])
                if (count == 7 || i == days.length - 1) {
                    weeks.push(week)
                    count = 0
                    week = []
                }
            }

            // console.log(weeks)

            let lastWeekLenght = weeks[weeks.length - 1].length
            if (lastWeekLenght < 7) {
                for (let i = 0; i < 7 - lastWeekLenght; i++) {
                    // console.log("HERE")
                    weeks[weeks.length - 1].push(null)
                }
            }


            // console.log(weeks)
            // console.log(weeks)
            count = 0

            let data = this.props.data
            if (data) {
                data = moment(data).valueOf()
            }

            return weeks.map((week, index) => {

                // if(index ==  )
                return (
                    <div key={'week' + index} className="d-flex text-center  w-100 " style={{ justifyContent: 'space-between' }}>

                        {week.map((day, index1) => {
                            // console.log(count)
                            if (day == null) {
                                return (
                                    <div key={index + index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                    </div>
                                )
                            } else {
                                count++

                                // console.log(data)
                                // console.log(day.start)

                                let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                                let selectedDay = (data >= day.start && data <= day.end) ? true : false

                                let available = true

                                if (this.props.endDate && day.start > this.props.endDate) {
                                    available = false
                                }

                                if (this.props.startDate && day.end < this.props.startDate) {
                                    available = false
                                }
                                // console.log(this.props.startDate)
                                // if()
                                return (
                                    <div onClick={() => { if (available) this.setDay(day) }} className="br-30" key={index + index1} style={{ border: isToday ? `1px solid ${this.props.colors?.primaryColor ?? "#007aff"}` : '1px solid #fff', padding: 1, background: isToday ? `${this.props.colors?.primaryColor ?? "#007aff"}10` : 'transparent', }}>
                                        <div key={index1} style={{ cursor: 'pointer', backgroundColor: selectedDay ? `${this.props.colors?.primaryColor ?? "#007aff"}` : 'transparent', padding: 0, borderRadius: 40, width: 32, height: 32, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                            <div style={{ borderRadius: 40, padding: 0, minWidth: 25, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <span style={{ color: available ? (selectedDay ? '#fff' : '#101010') : '#abc', fontSize: 12, fontWeight: 400 }}>{count}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                        }

                    </div>
                )
            })


        }

    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('scroll', this.getPosition);

    }

    toggleOpen(open) {
        // console.log("toggleOpen")

        let openState = open != null ? open : !this.state.isOpen

        // document.addEventListener('mousedown', this.closeBox);
        // window.addEventListener('scroll', this.getPosition, true);
        // this.getPosition()
        // if (openState) {
        this.fixedView.showView()
        // } else {
        //     this.fixedView.hideView()
        // }
        this.setState({ isOpen: true })
    }


    // closeBox = (event) => {
    //     if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
    //         this.setState({ isOpen: false, data: this.props.data })
    //         document.removeEventListener('mousedown', this.closeBox);
    //         window.removeEventListener('scroll', this.getPosition);

    //         if (this.refs.icon)
    //             this.refs.icon.classList.toggle("rotate-180")

    //     }
    // }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }

    setVariableValue = (item) => {

        this.props.changeValue(this.props.header.key, item.value, this.props.extra)

    }



    setTime = (key, value) => {

        let formatted = this.props.data
        let title = this.state.title

        console.log(value, title)
        if (title && !String(title).startsWith("{{")) {

            let timeByMin = this.timeStringToTimeByMin(value)
            formatted = moment(this.state.title).startOf('day').add(timeByMin, 'seconds').valueOf()

            console.log(formatted)
            this.props.changeValue(this.props.header.key, formatted, this.props.extra)

        }

        this.setState({ time: value }, () => {
        })
    }


    timeStringToTimeByMin(value) {

        let time = value.split(":")

        if (Array.isArray(time)) {

            time.forEach((element, i) => {
                if (element == 'undefined') {
                    time[i] = '00'
                }
            });

            return (Number(time[0]) * 3600) + Number(time[1] * 60) + Number(time[2])

        }

    }


    addTime = (add) => {
        this.setState({ showTime: add })

        if (add == false) {
            this.setState({ time: null })
            let title = this.state.title
            if (title && !String(title).startsWith("{{")) {
                let formatted = moment(this.state.title).startOf('day')

                let startOrEnd = this.props.header.information?.startOrEnd ?? "start"
                if (startOrEnd == 'end') {
                    formatted = moment(this.state.title).endOf('day')
                }
                this.props.changeValue(this.props.header.key, formatted, this.props.extra)

            }

        }

    }



    render() {

        let info = this.props.header.information

        return (
            <div className='mt-0 w-100 h-100 flexc' >

                <div className="text-start w-100" ref={el => this.listView = el} style={{ display: 'flex', maxWidth: 410, minWidth: 200 }}>

                    {info.showVariables && (
                        <div className="br-8 pt-2  flex-1 d-flex" style={{ background: "#f2f2f2", border: '1px solid #eee', width: 145 }}>
                            <div className="flex-1 w-100" style={{ overflow: "auto", }}>
                                <p className="font-size-14 text-semibold px-2 mb-1">{translate("Date variables")}</p>
                                {this.state.dateVariables.map((item, index) => {
                                    let selected = item.value == this.props.data

                                    return (
                                        <button key={index} onClick={() => this.setVariableValue(item)} className="time-list flexcb w-100" style={{ cursor: 'pointer', padding: '6px 8px', backgroundColor: selected ? '#007aff40' : '' }} >
                                            <p className="mrd-2 text-semibold font-size-12">{checkTranslation(item.name)}</p>
                                            <p className="opacity-5 font-size-11">{checkTranslation(item.date)}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )}

                    <div className={'search-drop-down flex-1'} style={{ direction: 'ltr', paddingBottom: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', width: 265, }}>

                        <div className="flexcb  px-0 flexcc " style={{}}>
                            {/* <i onClick={() => this.changeMonth(-1)} className="fa fa-arrow-right"></i> */}
                            <div className="flexc">
                                <button className="flexcc p-0">
                                    <img className="rotate-180" onClick={() => this.changeMonth(-1)} src="/assets/icons/next.svg" height="20px" alt="" />
                                </button>
                                <button className="flexcc p-0">
                                    <img className="rotate-180 opacity-2" onClick={() => this.changeYear(-12)} src="/assets/icons/next-double.svg" height="20px" alt="" />
                                </button>
                            </div>
                            <p className="font-size-14 text-semibold">{this.state.month.title}</p>
                            <div className="flexc">
                                <button className="flexcc p-0">
                                    <img className="opacity-2" onClick={() => this.changeYear(12)} src="/assets/icons/next-double.svg" height="20px" alt="" />
                                </button>

                                <button className="flexcc p-0">
                                    <img className="" onClick={() => this.changeMonth(1)} src="/assets/icons/next.svg" height="20px" alt="" />
                                </button>

                            </div>
                            {/* <i onClick={() => this.changeMonth(1)} className="fa fa-arrow-left"></i> */}
                        </div>

                        <div className="d-flex py-2 px-0 text-center w-100" style={{ justifyContent: 'space-between' }}>
                            {this.state.week.map((prop, index) => {
                                return (
                                    <div className={'w-100'} style={{ width: 35, }} key={'week' + index}>
                                        <p style={{ color: '#789', fontSize: 12 }}>{prop}</p>
                                    </div>
                                )
                            })}
                        </div>
                        {this.state.showDaysComponent && (
                            <>
                                {this.showDays()}
                            </>
                        )}
                        <div className="flexcb px-3 mb-1 pt-1" style={{ borderTop: !info.required ? '1px solid #eee' : '' }}>

                            {info.canAddTime && !this.state.showTime && !info.showTime && (
                                <button className=" py-1 flexc " onClick={() => this.addTime(true)}>
                                    <p className="mrd-2 text-link">+{translate("Add time")}</p>
                                </button>
                            )}


                            {(this.state.showTime || info.showTime) && (
                                <div className=" py-1 flexc " >
                                    <p className="mrd-2">{translate("Time")}</p>
                                    {/* {this.state.timeView && */}
                                    <div className="  p-2" style={{ background: '#cbcbcb42', width: 'fit-content', borderRadius: 8 }}>
                                        <TimeInput changeValue={this.setTime} header={{ key: 'time', information: { disabled: this.state.timeDisabled, seconds: false, } }} data={this.state.time} />
                                    </div>

                                    <button className="flexcc mld-2" onClick={() => this.addTime(false)}>
                                        <img className="opacity-7" src="/assets/icons/useful/x-mark.png" alt="" height={16} />
                                    </button>
                                    {/* } */}
                                </div>
                            )}
                            {!info.required && (
                                <div className="flexce flex-1">
                                    <button className="text-small text-link" onClick={() => this.props.changeValue(this.props.header.key, null, this.props.extra)}>
                                        <span>{translate("Clear date")}</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default MonthlyCalendarInput;
